import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormField } from '@angular/material/form-field';
import { MatOption, MatSelect } from '@angular/material/select';
import { ButtonClass, ButtonComponent } from '@claas/claas-ui-components';
import { TranslateModule } from '@ngx-translate/core';
import { IOrganisationListItem } from 'cde-fe-organization-registration-dialog';

export interface ChangeOrganisationDialogData {
  organisations: IOrganisationListItem[];
  currentOrganisation: IOrganisationListItem;
}

@Component({
  selector: 'app-change-organisation-dialog',
  templateUrl: './change-organisation-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ButtonComponent,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    MatFormField,
    MatOption,
    MatSelect,
    TranslateModule,
  ],
})
export class ChangeOrganisationDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<ChangeOrganisationDialogComponent>);
  protected readonly data = inject<ChangeOrganisationDialogData>(MAT_DIALOG_DATA);

  protected readonly buttonClass = ButtonClass;
  public selectedOrganisation: IOrganisationListItem = this.data.currentOrganisation ?? this.data.organisations[0];

  public onChange(): void {
    this.dialogRef.close(this.selectedOrganisation);
  }

  public compareOrganisations = (a: IOrganisationListItem, b: IOrganisationListItem): boolean =>
    a?.auth0Id === b?.auth0Id;
}
